import useAtomAssistEventHandlers from "./useAtomAssistEventHandlers";
import { useOwnChatStream } from "src/reusable/Chat/ChatStreaming/hooks/useOwnChatStream";
import { nuclearn_api_url } from "src/App";
import { ChatConfiguration } from "src/reusable/Chat/ChatStreaming/types";

export const useAtomAssistChat = (
  config?: Partial<ChatConfiguration>,
  dialogue?: any[],
) => {
  const { metadataHandler, messageHandler } = useAtomAssistEventHandlers();

  // A turn is saved only when it ends, so a snapshot refetched mid-turn lacks the message just sent.
  const streamingResult = useOwnChatStream(
    {
      api: `${nuclearn_api_url}/chat/start`,
      onMetadataEvent: metadataHandler,
      onMessageEvent: messageHandler,
      ...config,
    },
    dialogue,
    { mergeSeed: true },
  );

  // Don't sync streaming state to unified store - it causes unnecessary re-renders
  // Keep streaming state local to prevent component re-renders during streaming

  return streamingResult;
};
